import { Box, Typography } from "@mui/material";
import { DOCS_HEADING, DOCS_MUTED } from "../docsStyles";

export const DocNotFound = () => (
  <Box sx={{ py: 16, px: 6, textAlign: "center" }}>
    <Typography
      variant="h5"
      sx={{ mb: 2, color: DOCS_HEADING, fontWeight: 700 }}
    >
      Doc not found
    </Typography>
    <Typography sx={{ color: DOCS_MUTED }}>
      This page doesn't exist or may have moved. Pick a doc from the list.
    </Typography>
  </Box>
);
